module.exports = __webpack_public_path__ + "static/media/black_pin.5f0c1b8a.svg";